import { render, staticRenderFns } from "./OpsCollectionsList.vue?vue&type=template&id=90465c82&"
import script from "./OpsCollectionsList.vue?vue&type=script&lang=js&"
export * from "./OpsCollectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports